// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import NewIcon from 'components/common/Icons/NewIcon/NewIcon';
import './UserMenuItem.scss';

type Props = {
  to?: ?string,
  children: any,
  isNew: boolean,
};

const UserMenuItem = ({ to, isNew, children, ...rest }: Props) => {
  if (!to) {
    return (
      <span className="user-menu-item" {...rest}>
        {children}
      </span>
    );
  }

  return (
    <Link className="user-menu-item" to={to} {...rest}>
      <span>
        {children}
        {isNew && <NewIcon />}
      </span>
    </Link>
  );
};

UserMenuItem.defaultProps = {
  to: null,
};

export default UserMenuItem;



// WEBPACK FOOTER //
// ./src/components/base/UserMenuItem/UserMenuItem.js